/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupContractMemberDto
 */
export interface GroupContractMemberDto {
    /**
     * 
     * @type {string}
     * @memberof GroupContractMemberDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractMemberDto
     */
    contractIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractMemberDto
     */
    insuredName?: string | null;
    /**
     * Stable status code, for front logic.
     * @type {string}
     * @memberof GroupContractMemberDto
     */
    statusCode?: string | null;
    /**
     * Localized status label, for display only.
     * @type {string}
     * @memberof GroupContractMemberDto
     */
    statusLabel?: string | null;
    /**
     * Calendar date, no timezone — display as-is, never convert.
     * @type {string}
     * @memberof GroupContractMemberDto
     */
    startDate?: string | null;
    /**
     * True if the member carries a SEPA mandate. False means no direct debit can ever be issued for this contract.
     * @type {boolean}
     * @memberof GroupContractMemberDto
     */
    hasMandate: boolean;
    /**
     * RUM of the attached mandate. Null while the mandate is not signed, even when it is attached — the direct debit is impossible in that state too.
     * @type {string}
     * @memberof GroupContractMemberDto
     */
    mandateRum?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupContractMemberDto
     */
    paymentCount: number;
    /**
     * 
     * @type {number}
     * @memberof GroupContractMemberDto
     */
    paidCount: number;
    /**
     * 
     * @type {number}
     * @memberof GroupContractMemberDto
     */
    plannedCount: number;
    /**
     * Planned payments that already failed at least once.
     * @type {number}
     * @memberof GroupContractMemberDto
     */
    failedCount: number;
    /**
     * Payments that exhausted their attempts: they will not be retried without a manual intervention, even once the mandate is fixed.
     * @type {number}
     * @memberof GroupContractMemberDto
     */
    abandonedCount: number;
    /**
     * 
     * @type {number}
     * @memberof GroupContractMemberDto
     */
    totalAmount: number;
    /**
     * Calendar date, no timezone — display as-is, never convert.
     * @type {string}
     * @memberof GroupContractMemberDto
     */
    nextDueDate?: string | null;
}

/**
 * Check if a given object implements the GroupContractMemberDto interface.
 */
export function instanceOfGroupContractMemberDto(value: object): value is GroupContractMemberDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('contractIdentifier' in value) || value['contractIdentifier'] === undefined) return false;
    if (!('hasMandate' in value) || value['hasMandate'] === undefined) return false;
    if (!('paymentCount' in value) || value['paymentCount'] === undefined) return false;
    if (!('paidCount' in value) || value['paidCount'] === undefined) return false;
    if (!('plannedCount' in value) || value['plannedCount'] === undefined) return false;
    if (!('failedCount' in value) || value['failedCount'] === undefined) return false;
    if (!('abandonedCount' in value) || value['abandonedCount'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function GroupContractMemberDtoFromJSON(json: any): GroupContractMemberDto {
    return GroupContractMemberDtoFromJSONTyped(json, false);
}

export function GroupContractMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupContractMemberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contractIdentifier': json['contractIdentifier'],
        'insuredName': json['insuredName'] == null ? undefined : json['insuredName'],
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'statusLabel': json['statusLabel'] == null ? undefined : json['statusLabel'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'hasMandate': json['hasMandate'],
        'mandateRum': json['mandateRum'] == null ? undefined : json['mandateRum'],
        'paymentCount': json['paymentCount'],
        'paidCount': json['paidCount'],
        'plannedCount': json['plannedCount'],
        'failedCount': json['failedCount'],
        'abandonedCount': json['abandonedCount'],
        'totalAmount': json['totalAmount'],
        'nextDueDate': json['nextDueDate'] == null ? undefined : json['nextDueDate'],
    };
}

export function GroupContractMemberDtoToJSON(json: any): GroupContractMemberDto {
    return GroupContractMemberDtoToJSONTyped(json, false);
}

export function GroupContractMemberDtoToJSONTyped(value?: GroupContractMemberDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'contractIdentifier': value['contractIdentifier'],
        'insuredName': value['insuredName'],
        'statusCode': value['statusCode'],
        'statusLabel': value['statusLabel'],
        'startDate': value['startDate'],
        'hasMandate': value['hasMandate'],
        'mandateRum': value['mandateRum'],
        'paymentCount': value['paymentCount'],
        'paidCount': value['paidCount'],
        'plannedCount': value['plannedCount'],
        'failedCount': value['failedCount'],
        'abandonedCount': value['abandonedCount'],
        'totalAmount': value['totalAmount'],
        'nextDueDate': value['nextDueDate'],
    };
}

